import { render, staticRenderFns } from "./MenduserIndex.vue?vue&type=template&id=60cfa220"
import script from "./MenduserIndex.vue?vue&type=script&lang=js"
export * from "./MenduserIndex.vue?vue&type=script&lang=js"
import style0 from "./MenduserIndex.vue?vue&type=style&index=0&id=60cfa220&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports